import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=2e065e9f&scoped=true&"
import script from "./Note.vue?vue&type=script&lang=js&"
export * from "./Note.vue?vue&type=script&lang=js&"
import style0 from "./Note.vue?vue&type=style&index=0&id=2e065e9f&scoped=true&lang=less&"
import style1 from "./Note.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e065e9f",
  null
  
)

export default component.exports